module.exports = __webpack_public_path__ + "f91541f37ac0bbe2a95e4922ae0d9e66.svg";